import InfoIcon from '@clearkit/icons/glyphs/InfoHollow';
import { CKTooltip } from '@clearkit/react';
import Grid from '@material-ui/core/Grid';

import Bit from './Bit';
import styles from './QuadBit.style';

const QuadBitContext = React.createContext();

const QuadBit = ({
  loading,
  classes,
  className,
  children,
  horizontal,
  title,
  actions,
  ...props
}) => {
  return (
    <QuadBitContext.Provider value={{ horizontal, loading }}>
      <Bit {...props} className={classes.bit}>
        <Bit.Header>
          {title && <Bit.Title>{title}</Bit.Title>}
          {actions && <Bit.Actions>{actions}</Bit.Actions>}
        </Bit.Header>
        <Grid className={classnames(classes.grid, className)} container>
          {children}
        </Grid>
      </Bit>
    </QuadBitContext.Provider>
  );
};

QuadBit.propTypes = {
  loading: PropTypes.bool,
  classes: PropTypes.object,
  children: PropTypes.node,
  actions: PropTypes.node,
  title: PropTypes.string,
  horizontal: PropTypes.bool,
};

export const Metric = ({
  title,
  value,
  subtitle,
  classes,
  explanation,
  ...rest
}) => {
  const { horizontal, loading } = useContext(QuadBitContext);

  return (
    <Grid
      xs={6}
      md={horizontal ? 3 : 6}
      item
      className={classnames(classes.item, {
        [classes.horizontal]: horizontal,
      })}
      {...rest}>
      <div className="flex mb-2">
        <span className="text-gray-200">{title}</span>
        {explanation && (
          <CKTooltip
            unstable_portal
            tooltip={<p className="font-normal">{explanation}</p>}
            placement="top">
            <div className="ml-1 outline-none text-gray">
              <InfoIcon width="16" height="16" />
            </div>
          </CKTooltip>
        )}
      </div>
      <span className={classnames('text-gray-600', { 'ck-skeleton': loading })}>
        {loading ? 'Loading' : value}
      </span>
      <span
        className={classnames('text-gray-400 font-semibold', {
          'ck-skeleton': loading,
        })}>
        {subtitle}
      </span>
    </Grid>
  );
};

Metric.propTypes = {
  classes: PropTypes.object,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.string,
  explanation: PropTypes.string,
};

QuadBit.Metric = withStyles(styles)(Metric);

export default withStyles(styles)(QuadBit);
